const fetch = require('utils/fetchRequest');

export const getNews = async (query) => {
    try {
        const response = await fetch.get('news?' + query);
        return response.data;
    } catch (err) {
        return { error: 'Сервертэй холбогдож чадсангүй' };
    }
};

export const getCats = async () => {
    try {
        const response = await fetch.get('news/cats');
        return response.data;
    } catch (err) {
        return { error: 'Сервертэй холбогдож чадсангүй' };
    }
};

export const getOneNews = async (id) => {
    try {
        const response = await fetch.get('news/' + id);
        return response.data;
    } catch (err) {
        return { error: 'Сервертэй холбогдож чадсангүй' };
    }
};

export const addNews = async (datas) => {
    const result = await fetch.post('news', datas);
    return result;
};

export const editNews = async (datas, id) => {
    const result = await fetch.put('news/' + id, datas);
    return result;
};

export const deleteNews = async (id) => {
    const result = await fetch.destroy('news/' + id);
    return result;
};
